module.exports = __webpack_public_path__ + "static/media/A1-8-Clonnos-cod90.19c7d33e.png";